//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../Features/Features.Feature.js";
import "../no/MeasureManager.js";
let d=[[[0,"SequenceType",1,0],[0,"UpdateAtTimestamp",1,0]],[[["name"],"SetNameSuffix",{},1,0],[["element_index"],"GetMeasureElement",{R_:{element:"MeasureElement"}},1,0],[[],"FixupModelingParents",{},0,0],[[],"GetElementCount",{R_:{count:''}},0,0]],[]];
SPLM.MeasureMaster = class extends SPLM.Features.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MeasureMaster";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MeasureMaster.Sequence = Object.freeze({
    "Free" : "Free", "Pair" : "Pair", "Chain" : "Chain", "Reference" : "Reference", "Reference2" : "Reference2", "Reference3" : "Reference3", "ChainReference" : "ChainReference"});

export default SPLM;